export const TYPES = ["Revenue", "Quantity"];
